const TRANSLATED_STRING = {
    "7_day_is_free": {
        fr: "7ème jour offert",
        en: "7th day free",
        nl: "7e dag gratis",
    },
    "add_pack": {
        fr: "Ajouter materiel",
        en: "Add equipment",
        nl: "Voeg apparatuur toe",
    },
    "cart": {
        fr: "Panier",
        en: "Cart",
        nl: "Winkelwagen",
    },
    "at": {
        fr: "à",
        en: "in",
        nl: "in",
    },
    "cancel": {
        fr: "Annuler",
        en: "Cancel",
        nl: "Cancel",
    },
    "cart_discount": {
        fr: "Remise",
        en: "Discount",
        nl: "Korting",
    },
    "cart_instead_of": {
        fr: "au lieu de",
        en: "instead of",
        nl: "in plaats van",
    },
    "cart_promo_code": {
        fr: "Code promo",
        en: "Promo code",
        nl: "Promotiecode",
    },
    "cart_total_internet": {
        fr: "Total prix Internet",
        en: "Price through internet",
        nl: "Prijs internet boeking",
    },
    "cart_total_shop": {
        fr: "Total prix public magasin",
        en: "Total normal price in the shop",
        nl: "Totaal publieke prijs in de winkel",
    },
    "cart_truncate": {
        fr: "Vider le panier",
        en: "Empty cart",
        nl: "Empty cart",
    },
    "cart_warranty": {
        fr: "Garantie perte/vol/casse",
        en: "Warranty for theft/Loss/ breakage",
        nl: "Garantie tegen diefstal/verlies/beschadigen",
    },
    "checkout_confirm": {
        fr: "Confirmer ma réservation",
        en: "Confirm my reservation",
        nl: "Bevestig mijn reservering"
    },
    "close": {
        fr: "Fermer",
        en: "Close",
        nl: "Sluiten"
    },
    "continue_order": {
        fr: "Ajouter du matériel",
        en: "Add equipment",
        nl: "Voeg apparatuur toe"
    },
    "day": {
        fr: "jour(s)",
        en: "day(s)",
        nl: "dag(en)",
    },
    "day_single": {
        fr: "jour",
        en: "day",
        nl: "dag",
    },
    "delete": {
        fr: "Supprimer",
        en: "Remove",
        nl: "Verwijderen"
    },
    "edit": {
        fr: "Modifier",
        en: "Edit",
        nl: "Bewerken"
    },
    "empty_list": {
        fr: "Votre liste est vide !",
        en: "Your cart is empty!",
        nl: "uw winkelwagen is leeg !"
    },
    "finish_order": {
        fr: "Terminer ma commande",
        en: "Finish my booking",
        nl: "Rond mijn boeking af"
    },
    "for": {
        fr: "pour",
        en: "for",
        nl: "voor"
    },
    "helmet": {
        fr: "Casque",
        en: "Helmet",
        nl: "Helm"
    },
    "infos_validate": {
        fr: "Confirmer ma commande",
        en: "Confirm my booking",
        nl: "Bevestig mijn boeking",
    },
    "label_address": {
        fr: "Adresse",
        en: "Adress",
        nl: "Adres",
    },
    "label_city": {
        fr: "Ville",
        en: "City",
        nl: "Plaats",
    },
    "label_country": {
        fr: "Pays",
        en: "Country",
        nl: "Land",
    },
    "label_email": {
        fr: "E-Mail *",
        en: "E-Mail *",
        nl: "E-Mail *",
    },
    "label_firstname": {
        fr: "Prénom *",
        en: "Firstname *",
        nl: "Voornaam *",
    },
    "label_lastname": {
        fr: "Nom *",
        en: "Lastname *",
        nl: "Naam *",
    },
    "label_mobile_phone": {
        fr: "Téléphone mobile *",
        en: "Mobile phone *",
        nl: "Mobiel telefoon nummer *",
    },
    "label_ski_resort_address": {
        fr: "Adresse sur la station",
        en: "Address in ski resort",
        nl: "Adres in het skiresort",
    },
    "label_selloff": {
        fr: "Code promo",
        en: "Promo code",
        nl: "Promotiecode",
    },
    "label_zipcode": {
        fr: "Code postal",
        en: "Zip Code",
        nl: "Post code",
    },
    "legal_notice": {
        fr: "Mentions légales",
        en: "Legal notice",
        nl: "Luridische kennisgeving",
    },
    "level": {
        fr: "niveau",
        en: "level",
        nl: "niveau",
    },
    "list.confirmation_book_free": {
        fr: "pas de frais de dossier",
        en: "no booking fees",
        nl: "Geen dossier kosten",
    },
    "list.confirmation_free_cancelation": {
        fr: "annulation gratuite",
        en: "free cancellation",
        nl: "Gratis annuleren",
    },
    "list.confirmation_no_deposit": {
        fr: "pas d'acompte à la réservation",
        en: "no deposit for your booking",
        nl: "Geen aanbetaling voor uw reservering",
    },
    "list.confirmation_order_edit": {
        fr: "modification de commande en magasin possible",
        en: "modification of your order possible in the shop",
        nl: "Veranderen van uw reservering is mogelijk in de winkel",
    },
    "list.confirmation_pay": {
        fr: "paiement en magasin à votre arrivée",
        en: "pay when you arrive in the shop",
        nl: "Betaal in de winkel bij aankomst",
    },
    "menu.accueil": {
        fr: "accueil",
        en: "home",
        nl: "welcom"
    },
    "menu.booking": {
        fr: "réserver",
        en: "book online",
        nl: "reserving"
    },
    "menu.contact": {
        fr: "contact",
        en: "contact",
        nl: "contact"
    },
    "menu.practical": {
        fr: "pratique",
        en: "practical",
        nl: "practical"
    },
    "menu.prices": {
        fr: "skis / tarifs",
        en: "rental rates",
        nl: "prijzen"
    },
    "menu.team": {
        fr: "l'équipe",
        en: "the team",
        nl: "het team"
    },
    "navigation.selection": {
        fr: "matériel",
        en: "equipment",
        nl: "equipment"
    },
    "navigation.finish": {
        fr: "récapitulatif",
        en: "summary",
        nl: "samenvatting"
    },
    "navigation.checkout": {
        fr: "validation",
        en: "checkout",
        nl: "Uitchecken"
    },
    "no_deposit": {
        fr: "sans frais de dossier ni acompte",
        en: "without deposit nor fee",
        nl: "zonder aanbetaling of administratie kosten",
    },
    "placeholder_day": {
        fr: "Nombre de jours",
        en: "Day(s)",
        nl: "Dag(en)",
    },
    "placeholder_size": {
        fr: "Taille",
        en: "Height",
        nl: "Lengte",
    },
    "placeholder_shoe_size": {
        fr: "Pointure",
        en: "Shoe size",
        nl: "Height",
    },
    "placeholder_weight": {
        fr: "Poids",
        en: "Weight",
        nl: "Schoenmaat",
    },
    "sentence.accordance": {
        fr: "Conformément aux dispositions de la loi du n°78-17 du 6 janvier 1978, vous disposez d'un droit d'accès, de rectification et d'opposition sur les données nominatives vous concernant.",
        en: "In accordance with the provisions of the law n ° 78-17 of January 6, 1978, you have the right to access, rectify and oppose personal data concerning you.",
        nl: "In overeenstemming met de bepalingen van de wet nr. 78-17 van 6 januari 1978, hebt u het recht op toegang tot, rectificatie van en verzet tegen uw persoonlijke gegevens.",
    },
    "sentence.confirmation": {
        fr: "Votre matériel pour votre séjour à partir du {0} pour {1} jour(s).",
        en: "Your material for your stay from {0} for {1} day(s).",
        nl: "Uw materiaal voor uw verblijf vanaf {0} voor {1} dag(en).",
    },
    "sentence.material_example": {
        fr: "Exemple de matériel",
        en: "Example of the material",
        nl: "Voorbeeld van het materiaal",
    },
    "sentence.my_list": {
        fr: "Ma liste de matériel",
        en: "My equipment list",
        nl: "Overzicht van mijn materiaal"
    },
    "sentence.my_list_instructions": {
        fr: "Note : pour que votre matériel soit correctement préparé à l’avance, vous pouvez indiquer votre taille et votre pointure. Ces informations sont facultatives. Photos et modèles non contractuels, les équipements sont choisis en fonction du magasin et des stocks à disposition.",
        en: "To assure we prepare the right gear for you please state your bodyweight and height. These details are facultative. Ski gear might differ from the pictures and is selected according the stock available in the shop.",
        nl: "Let op: om zeker te zijn dat uw materiaal goed wordt voorbereidt dient u uw gewicht en lengte aan te geven. Deze gegevens zijn niet verplicht. Materiaal kan afwijken van de foto’s, en wordt geselecteerd aan de hand van het aanwezige materiaal in de voorraad."
    },
    "sentence.sport200_booking": {
        fr: "Vous pouvez aussi réservez vos skis (avec versement d\"acompte) via notre partenaire Sport2000.",
        en: "Book online with deposit with our partner Sport2000.",
        nl: "Book online with deposit with our partner Sport2000.",
    },
    "sentence.your_material": {
        fr: "Votre matériel pour votre séjour à partir du",
        en: "Your material for your stay from",
        nl: "Uw materiaal voor uw verblijf vanaf",
    },
    "shoes": {
        fr: "Chaussures",
        en: "Shoes",
        nl: "Schoenen",
    },
    "ski_rental": {
        fr: "location de skis",
        en: "skis rental",
        nl: "skiverhuur",
    },
    "skiman_name": {
        fr: "Prénom du skieur",
        en: "Skier firstname",
        nl: "Voornaam van de skier",
    },
    "validate": {
        fr: "Valider",
        en: "Validate",
        nl: "Valideer",
    },
    "view_order": {
        fr: "Voir ma commande",
        en: "View my order",
        nl: "Bekijk mijn bestelling",
    },
    "warranty_info_list1": {
        fr: "{0} pour skis, snowboards ou packs adulte primo, vert, bleu, rouge, mini ski, noir, free style.",
        en: "{0} for skis, snowboards or baby, junior blue and red junior packs.",
        nl: "{0} voor ski's, snowboards of baby, junior blauwe en rode junior packs.",
    },
    "warranty_info_list2": {
        fr: "{0} pour les skis, snowboards ou packs enfant baby, junior bleus, junior rouges.",
        en: "{0} for skis, snowboards or primo adult packs, green, blue, red, mini ski, black, free style.",
        nl: "{0} voor ski's, snowboards of primo-packs voor volwassenen, groen, blauw, rood, miniski, zwart, gratis stijl.",
    },
    "warranty_info_list3": {
        fr: "{0} pour les skis ou packs diamant, free ride, free rando, infinity.",
        en: "{0} for skis or diamond packs, free ride, free rando, infinity.",
        nl: "{0} voor ski's of diamantpakketten, gratis rit, gratis rando, oneindig.",
    },
    "warranty_info_list4": {
        fr: "L’assuré remboursera au magasin de retrait du dit matériel le montant total du préjudice.",
        en: "The insured will reimburse the store for collecting said equipment for the total amount of the damage.",
        nl: "Verzekerde vergoedt het totale schadebedrag aan de winkel voor het ophalen van deze apparatuur.",
    },
    "warranty_info_list5": {
        fr: "Après instruction et acceptation du Sinistre garanti, l’assureur procédera ensuite à l’indemnisation du préjudice déduction faite de la franchise contractuelle à l’assuré.",
        en: "After investigation and acceptance of the Insured Claim, the insurer will then proceed to compensation for the loss less the contractual deductible to the insured.",
        nl: "Na onderzoek en acceptatie van de verzekerde claim zal de verzekeraar overgaan tot vergoeding van de schade verminderd met het contractuele eigen risico van de verzekerde.",
    },
    "warranty_info_sentence1": {
        fr: "En cas de dommage matériel accidentel du Matériel de ski garanti : prise en charge de la réparation ou du remplacement du Matériel de ski garanti si ce dernier n’est pas réparable ou économiquement irréparable, dans la limite de 600 € par Matériel de ski garanti et après application d’une franchise.",
        en: "In the event of accidental material damage to the guaranteed ski equipment: reimbursement of the repair or replacement of the guaranteed ski equipment if the latter is not repairable or economically irreparable, in the limit of € 600 per guaranteed ski equipment and after application of an excess.",
        nl: "In geval van accidentele materiële schade aan de gegarandeerde ski-uitrusting: vergoeding van de reparatie of vervanging van de gegarandeerde ski-uitrusting als deze niet repareerbaar of economisch onherstelbaar is, in de limiet van € 600 per gegarandeerde skiuitrusting en na toepassing van een eigen risico.",
    },
    "warranty_info_sentence2": {
        fr: "En cas de vol simple ou de vol par effraction du Matériel de ski garanti : prise en charge des frais de remplacement du Matériel de ski garanti, dans la limite de 600 € par Matériel de ski garanti et après application d’une franchise.",
        en: "In the event of simple theft or theft by breaking and entering of the guaranteed ski equipment: coverage of the replacement costs of the guaranteed ski equipment, up to a limit of € 600 per guaranteed ski equipment and after application of an excess.",
        nl: "In geval van eenvoudige diefstal of diefstal door inbraak in de gegarandeerde ski-uitrusting: dekking van de vervangingskosten van de gegarandeerde ski-uitrusting, tot een limiet van € 600 per gegarandeerde ski-uitrusting en na toepassing van een eigen risico.",
    },
    "warranty_info_sentence3": {
        fr: "La franchise laissée à la charge de l’assuré est fixée en fonction de la catégorie de Matériel de ski garanti :",
        en: "The deductible left to the insured is set according to the category of guaranteed ski equipment:",
        nl: "Het eigen risico dat aan de verzekerde wordt overgelaten, wordt bepaald volgens de categorie van gegarandeerde ski-uitrusting:",
    },
    "warranty_info_sentence4": {
        fr: "La garantie est limitée à un seul sinistre par Matériel de ski garanti et par période d’assurance.",
        en: "The guarantee is limited to a single claim per guaranteed ski equipment and per insurance period.",
        nl: "De garantie is beperkt tot één claim per gegarandeerde ski-uitrusting en per verzekeringsperiode.",
    },
    "warranty_info_sentence5": {
        fr: "En cas de vol ou de casse du matériel, la procédure d’indemnisation est la suivante :",
        en: "In the event of theft or breakage of the equipment, the compensation procedure is as follows:",
        nl: "In geval van diefstal of breuk van de apparatuur is de compensatieprocedure als volgt:",
    },
    "warranty_info_subtitle": {
        fr: "Indemnisation",
        en: "Compensation",
        nl: "Een vergoeding",
    },
    "warranty_info_title": {
        fr: "Garantie perte/vol/casse",
        en: "Warranty for theft/loss/ breakage",
        nl: "Garantie tegen diefstal/verlies/beschadigen",
    },
};

export default {
    install(Vue) {
        Vue.filter("appTranslate", (obj, key) => {
            let LOCALE = localStorage.getItem("selectedLocale") || "fr";
            return obj.translations[LOCALE][key];
        });

        Vue.filter("globalTranslate", (key, params) => {
            let LOCALE = localStorage.getItem("selectedLocale") || "fr";
            if (!(key in TRANSLATED_STRING)) {
                throw new Error(`Key '${key}' not foud in 'TRANSLATED_STRING' object`);
            }
            let translated = TRANSLATED_STRING[key][LOCALE];
            if (params) {
                translated = translated.format(params[0], params[1]);
            }
            return translated;
        });
    }
}
